import React from "react";
import { Button, TextField, Stack, CircularProgress, Box } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { useFormik } from "formik";
import { REPORTESRANGOFECHA } from "../../../graphql/reporteador";
import { useLazyQuery } from "@apollo/client";
import Moment from "moment";
const FrmReportByDates = ({ setDatos, setOpenDialog, setTitle }) => {
  const [reporteCobrosPorDia, { loading, error, data }] =
    useLazyQuery(REPORTESRANGOFECHA);
  const formik = useFormik({
    initialValues: {
      fechaInicio: "",
      fechaFin: "",
    },
    onSubmit: async (inputData) => {
      try {
        if (inputData.fechaFin < inputData.fechaInicio) {
          throw Error("La fecha de Fin no puede ser menor a la de inicio");
        }
        const datos = await reporteCobrosPorDia({
          variables: {
            fechaInicio: inputData.fechaInicio,
            fechaFin: inputData.fechaFin,
          },
        });

        setDatos(datos.data.reportesRangoFechas);
        setOpenDialog(false);
        setTitle(
          `Reporte de la fecha ${Moment(inputData.fechaInicio).format(
            "DD-MMMM-YYYY"
          )} a la fecha ${Moment(inputData.fechaFin).format("DD-MMMM-YYYY")}`
        );
      } catch (error) {
        console.log(error);
      }
    },
  });

  if (loading)
    return (
      <>
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </>
    );

  //Call Information from the backend
  const handleOpenDialog = () => {
    setOpenDialog(false);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            onChange={(date) => formik.setFieldValue("fechaInicio", date)}
            value={formik.values.fechaInicio}
            renderInput={(params) => (
              <TextField
                {...params}
                name="fechaInicio"
                fullWidth
                variant="standard"
                label="Fecha de Inicio"
              />
            )}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            onChange={(date) => formik.setFieldValue("fechaFin", date)}
            value={formik.values.fechaFin}
            renderInput={(params) => (
              <TextField
                {...params}
                name="fechaFin"
                fullWidth
                variant="standard"
                label="Fecha de Fin"
              />
            )}
          />
        </LocalizationProvider>
      </Stack>

      <Stack direction="row" alignItems="center" sx={{ my: 2 }}>
        <Button type="submit">Filtrar</Button>
        <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
      </Stack>
    </form>
  );
};

export default FrmReportByDates;
